module.exports = __webpack_public_path__ + "img/img15.7d254b70.svg";